<template>
  <div>
    <div class="record3">
        <el-table stripe border :data="tableData" tooltip-effect="dark" style="width: 98%">
          <el-table-column align='center' prop="name" label="姓名" :width="row.dynamic_form_field&&row.dynamic_form_field.length?'120':''"></el-table-column>
          <el-table-column align='center' label="性别" width="90px">
            <template slot-scope="scope">
              <span>{{ scope.row.sex | isSex }}</span>
            </template>
          </el-table-column>
          <el-table-column align='center' prop="phone" label="手机号" :width="row.dynamic_form_field&&row.dynamic_form_field.length?'140':''"></el-table-column>
          
          <el-table-column align='center' :formatter="(row) => formatter(row, item)" :label="item.title" v-for="(item,i) in row.dynamic_form_field" :key="i">
            <template slot-scope="scope">
              <!-- {{ scope.row  }} -->
              <template v-if="item.field_key.indexOf('image') > -1">
                <img class="pic" @click="imgUrl=img;dialogVisible=true" :src="img" alt="" v-for="(img,k) in scope.row[item.field_key]" :key="k">
              </template>
              <template v-else-if="item.field_key.indexOf('file') > -1">
                <el-link><a :href='file' target="_blank" v-for="(file,f) in scope.row[item.field_key]" :key="f">附件{{ f+1 }}</a></el-link>
              </template>
              <template v-else>
                <template v-if="scope.row[item.field_key]">
                  <span v-for="(val,v) in scope.row[item.field_key]" :key="v">{{ val }}</span>
                </template>
              </template>
            </template>
          </el-table-column>

          <el-table-column align='center' prop="created_at" label="报名时间"  :width="row.dynamic_form_field&&row.dynamic_form_field.length?'140':''"></el-table-column>
          <el-table-column align='center' label="状态"  :width="row.dynamic_form_field&&row.dynamic_form_field.length?'100':''">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 10" style="color: #999999">已投递</span>
              <span v-if="scope.row.status == 20" style="color: rgb(13, 205, 46);">已录用</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align='center'  :width="row.dynamic_form_field&&row.dynamic_form_field.length?'240':''">
            <template slot-scope="scope" v-if="JudgeButton(role_permission,'recruit/editDelivery')">
              <el-button v-if="scope.row.status == 10" size="mini" type="primary"
                @click="reset(scope.row, 20, '录用')">录用</el-button>
              <el-button v-if="scope.row.status == 20" size="mini" type="warning"
                @click="reset(scope.row, 10, '取消录用')">取消录用</el-button> 
            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 30px 0;">
          <el-button v-if="JudgeButton(role_permission,'recruit/exportDelivery')" @click="download()" icon="el-icon-download" type="primary" style="margin-right: 30px;">导出PDF</el-button>
          <el-button @click="$router.back()" icon="el-icon-arrow-left">返回</el-button>
        </div>
    </div>
    
    
    
    
    <div id="pdfDom" style="padding: 30px;position: fixed;right: -99999px;">
      <h2>{{ row.name }}报名名单</h2>
      <p>打印时间：{{ date }}</p>
      <el-table border :data="tableData" tooltip-effect="dark"
      :header-cell-style="{
        'background': '#CECFCF',
        color: '#333'
      }"
      :cell-style="{
        'border-color': '#C2C5C4'
      }"
      >
        <el-table-column align='center'  label="序号" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        
        <el-table-column align='center' prop="name" label="姓名" :width="row.dynamic_form_field&&row.dynamic_form_field.length?'120':''"></el-table-column>
        <el-table-column align='center' label="性别" width="90px">
          <template slot-scope="scope">
            <span>{{ scope.row.sex | isSex }}</span>
          </template>
        </el-table-column>
        <el-table-column align='center' prop="phone" label="手机号" :width="row.dynamic_form_field&&row.dynamic_form_field.length?'140':''"></el-table-column>
        
        <el-table-column align='center' :formatter="(row) => formatter(row, item)" :label="item.title" v-for="(item,i) in row.dynamic_form_field" :key="i">
          <template slot-scope="scope">
            <template v-if="item.field_key.indexOf('image') > -1">
              <img class="pic" @click="imgUrl=img;dialogVisible=true" :src="img" alt="" v-for="(img,k) in scope.row[item.field_key]" :key="k">
            </template>
            <template v-else-if="item.field_key.indexOf('file') > -1">
              <el-link><a :href='file' target="_blank" v-for="(file,f) in scope.row[item.field_key]" :key="f">附件{{ f+1 }}</a></el-link>
            </template>
            <template v-else>
              <template v-if="scope.row[item.field_key]">
                <span v-for="(val,v) in scope.row[item.field_key]" :key="v">{{ val }}</span>
              </template>
            </template>
          </template>
        </el-table-column>
        <el-table-column align='center' prop="created_at" label="报名时间"  :width="row.dynamic_form_field&&row.dynamic_form_field.length?'150':''"></el-table-column>
        <el-table-column align='center' label="状态"  :width="row.dynamic_form_field&&row.dynamic_form_field.length?'100':''">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 10">{{ scope.row.status_description }}</span>
            <span v-if="scope.row.status == 20">{{ scope.row.status_description }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    
    
    <el-dialog
      title="查看图片"
      :visible.sync="dialogVisible"
      width="40%"
      center
      >
      <img :src="imgUrl" alt="" style="display: block;width: 100%;">
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import userInfoAPI from '@/api/api';
  var that;
  export default {
    props: {},
    data() {
      return {
        loading: true,
        row: '',
        types: [
          {label: '志愿者招募', value: 'volunteer'},
          {label: '活动中心', value: 'center'}
        ],
        dialogVisible: false,
        imgUrl: '',
        tableData: [],
        date: ''
      }
    },
    computed: {
      role_permission() {
        return this.$store.getters.role_permission
      }
    },
    beforeDestroy() {
      
    },
    created() {
      if(this.$route.query.row){
        this.row = JSON.parse(this.$route.query.row)
        let dynamic_form_field = this.row.dynamic_form_field
        let recruitment_delivery = this.row.recruitment_delivery
        if(recruitment_delivery && recruitment_delivery.length){
          recruitment_delivery.forEach(item=>{
            if(item.dynamic_form_value && item.dynamic_form_value.length){
              item.dynamic_form_value.forEach(val=>{
                item[val.field_key] = val.field_value
              })
            }
          })
          this.tableData = recruitment_delivery
        }
        console.log(this.tableData)
      }
      this.loading = false
    },
    methods: {
      formatter(row, item){
        return row[item.field_key]
      },
      reset(row, status, txt){
        this.$confirm('是否确定'+txt+'该人员？', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          userInfoAPI.updateApplicant(row.id,{
            status:  status// 10:已投递,20:已录用
          }).then(res => {
            if (res.data.code == 0) {
              row.status = status
              this.$message.success(res.data.msg)
            }
          })
        })
      },
      JudgeButton(list, rot) {
        let fal = false;
        list.forEach((i, l) => {
          if (i.path == rot) {
            return fal = true;
          }
        })
        return fal
      },
      download(){
        let date = new Date()
        let year = date.getFullYear()
        let month = date.getMonth() + 1
        month = month < 9 ? '0' + month : month
        let day = date.getDate()
        day = day < 9 ? '0' + day : day
        let hour = date.getHours()
        hour = hour < 9 ? '0' + hour : hour
        let minute = date.getMinutes()
        minute = minute < 9 ? '0' + minute : minute
        let second = date.getSeconds()
        second = second < 9 ? '0' + second : second
        this.date = year + '-' +  month + '-' + day + ' '+ hour + ':' + minute
        setTimeout(()=>{
          this.getPdf(this.row.name+'招聘名单')
        },100)
      }
    }
  }
</script>
<style lang="scss" scoped>
  img.pic{
    width: 50px;
    height: 50px;
    border-radius: 4px;
  }
  .record3 {
    padding: 20px;
    overflow-x: auto;
  }
  h2{
    text-align: center;
    padding: 30px;
  }
  p{
    margin-bottom: 20px;
    text-align: right;
  }
</style>
